import { Validators } from '@angular/forms'

export const AssetIdValidator = Validators.pattern(/.*/)
